<!--
 * @Description: 成交明细面板
 * @Author: aihh
 * @Date: 2019-09-03
 * @LastEditTime: 2019-09-03
 * @LastEditors: aihh
 -->
<template>
  <div class="box" v-if="showHand === 1">
    <!--    <div class="title">成交明细</div>-->
    <!--指数/通用样式-->
    <ul class="tab-header">
      <li>Time</li>
      <li v-if="isMRI">Point</li>
      <li v-else>Point</li>
      <li v-if="isMRI">Turnover</li>
      <li v-else class="upOrDown"><span class="upOrDownSpan">Turnover</span></li>
    </ul>
    <div
      style="flex: 1;overflow-y: auto;width: 100%"
      class="innerbox scroll_bar_wzj"
    >
      <ul
        v-for="item in tickData"
        :key="item.business_time"
        style="line-height:32px"
      >
        <li>

          {{
            item[getIndex(fields, "business_time")]
              .toString()
              .substr(8, 4)
              .match(/\d{1,2}/g)
              .join(":")
          }}
        </li>
        <li v-if="item[getIndex(fields, 'hq_px')] === preclosePx">
          <span>
            {{ item[1].toFixed(fixedNumType) }}
          </span>
        </li>
        <li
          v-else
          :style="{
            color:
              item[getIndex(fields, 'hq_px')] > preclosePx
                ? '#EF4342'
                : '#2AB447'
          }"
        >
          <span>
            {{ item[getIndex(fields, "hq_px")].toFixed(fixedNumType) }}
          </span>
        </li>
        <li v-if="isMRI">
          <span>
            {{ numberFormats(item[getIndex(fields, "business_balance")]) }}
          </span>
        </li>
        <li class="upOrDown" v-else>
          <span
            v-if="item[getIndex(fields, 'business_direction')] === 2"
            style="color: black"
            >{{
              numberFormats(
                item[getIndex(fields, "business_amount")] /
                  (checkHKM(prod_code) ? 1 : perHand)
              )
            }}</span
          >
          <span
            v-else
            :style="{
              color:
                item[getIndex(fields, 'business_direction')] === 1
                  ? '#EF4342'
                  : '#2AB447'
            }"
          >
            {{
              numberFormats(
                item[getIndex(fields, "business_amount")] /
                  (checkHKM(prod_code) ? 1 : perHand)
              )
            }}</span
          >
          <b
            v-if="item[getIndex(fields, 'business_direction')] === 2"
            style="color: gray"
            >↑</b
          >
          <b
            v-else
            :style="{
              color:
                item[getIndex(fields, 'business_direction')] === 1
                  ? '#EF4342'
                  : '#2ab447'
            }"
          >
            {{
              item[getIndex(fields, "business_direction")] === 1 ? "↑" : "↓"
            }}</b
          >

          <!--            <img v-if="item[getIndex(fields,'business_direction')]==2" :src="require('../../assets/image/upGray.png')" />-->
          <!--            <img v-else :src="item[getIndex(fields,'business_direction')]==1?require('../../assets/image/upRed.png'):require('../../assets/image/downGreen.png')"/>-->
        </li>
        <li v-if="tickData.length < 12" style="width: 6px"></li>
      </ul>
    </div>
    <div style="height: 1px;"></div>
  </div>
  <!-- 深圳样式 -->
  <div class="box1" v-else-if="showHand === 2">
    <ul class="tab-header">
      <li>时间</li>
      <li>价格</li>
      <li class="upOrDown"><span class="upOrDownSpan">手数</span></li>
      <li>笔数</li>
    </ul>
    <div
      style="flex: 1;overflow-y: auto;width: 100%"
      class="innerbox scroll_bar_wzj"
    >
      <ul
        v-for="item in tickData"
        :key="item.business_time"
        style="line-height:32px;"
      >
        <li>
          {{
            item[getIndex(fields, "business_time")]
              .toString()
              .substr(8, 4)
              .match(/\d{1,2}/g)
              .join(":")
          }}
        </li>
        <li v-if="item[getIndex(fields, 'hq_px')] === preclosePx">
          <span>
            {{ item[1].toFixed(fixedNumType) }}
          </span>
        </li>
        <li
          v-else
          :style="{
            color:
              item[getIndex(fields, 'hq_px')] > preclosePx
                ? '#EF4342'
                : '#2AB447'
          }"
        >
          <span>
            {{ item[getIndex(fields, "hq_px")].toFixed(fixedNumType) }}
          </span>
        </li>
        <li class="upOrDown">
          <span
            v-if="item[getIndex(fields, 'business_direction')] === 2"
            style="color: black"
            >{{
              numberFormats(
                item[getIndex(fields, "business_amount")] /
                  (checkHKM(prod_code) ? 1 : perHand)
              )
            }}</span
          >
          <span
            v-else
            :style="{
              color:
                item[getIndex(fields, 'business_direction')] === 1
                  ? '#EF4342'
                  : '#2AB447'
            }"
          >
            {{
              numberFormats(
                item[getIndex(fields, "business_amount")] /
                  (checkHKM(prod_code) ? 1 : perHand)
              )
            }}</span
          >
          <b
            v-if="item[getIndex(fields, 'business_direction')] === 2"
            style="color: gray"
            >↑</b
          >
          <b
            v-else
            :style="{
              color:
                item[getIndex(fields, 'business_direction')] === 1
                  ? '#EF4342'
                  : '#2ab447'
            }"
          >
            {{
              item[getIndex(fields, "business_direction")] === 1 ? "↑" : "↓"
            }}</b
          >

          <!--            <img v-if="item[getIndex(fields,'business_direction')]==2" :src="require('../../assets/image/upGray.png')" />-->
          <!--            <img v-else :src="item[getIndex(fields,'business_direction')]==1?require('../../assets/image/upRed.png'):require('../../assets/image/downGreen.png')"/>-->
        </li>
        <li>
          <span>
            {{ item[getIndex(fields, "business_count")] }}
          </span>
        </li>
        <li v-if="tickData.length < 12" style="width: 6px"></li>
      </ul>
    </div>
    <div style="height: 1px;"></div>
  </div>
  <!-- 期货样式 -->
  <div class="box1" v-else-if="showHand === 3">
    <ul class="tab-header">
      <li>时间</li>
      <li>价格</li>
      <li class="upOrDown"><span class="upOrDownSpan">现手</span></li>
      <li>增仓</li>
    </ul>
    <div
      style="flex: 1;overflow-y: auto;width: 100%"
      class="innerbox scroll_bar_wzj"
    >
      <ul
        v-for="item in tickData"
        :key="item.business_time"
        style="line-height:32px;"
      >
        <li>
<!--          {{item[getIndex(fields, "business_time").toString()]}}-->
          {{
            item[getIndex(fields, "business_time")]
              .toString()
              .substr(8)
              .match(/\d{1,2}/g)
              .join(":")
          }}
        </li>
        <li v-if="item[getIndex(fields, 'hq_px')] === preclosePx">
          <span>
            {{ item[1].toFixed(fixedNumType) }}
          </span>
        </li>
        <li
          v-else
          :style="{
            color:
              item[getIndex(fields, 'hq_px')] > preclosePx
                ? '#EF4342'
                : '#2AB447'
          }"
        >
          <span>
            {{ item[getIndex(fields, "hq_px")].toFixed(fixedNumType) }}
          </span>
        </li>
        <li class="upOrDown">
          <span
            v-if="item[getIndex(fields, 'business_direction')] === 2"
            style="color: black"
          >
            {{ item[getIndex(fields, "business_amount")] }}
          </span>
          <span
            v-else
            :style="{
              color:
                item[getIndex(fields, 'business_direction')] === 1
                  ? '#EF4342'
                  : '#2AB447'
            }"
          >
            {{ item[getIndex(fields, "business_amount")] }}</span
          >
          <b
            v-if="item[getIndex(fields, 'business_direction')] === 2"
            style="color: gray"
            >↑</b
          >
          <b
            v-else
            :style="{
              color:
                item[getIndex(fields, 'business_direction')] === 1
                  ? '#EF4342'
                  : '#2ab447'
            }"
          >
            {{
              item[getIndex(fields, "business_direction")] === 1 ? "↑" : "↓"
            }}</b
          >

          <!--            <img v-if="item[getIndex(fields,'business_direction')]==2" :src="require('../../assets/image/upGray.png')" />-->
          <!--            <img v-else :src="item[getIndex(fields,'business_direction')]==1?require('../../assets/image/upRed.png'):require('../../assets/image/downGreen.png')"/>-->
        </li>
        <li>
          <span
            :class="[
              { red: item[getIndex(fields, 'amount')] > 0 },
              { green: item[getIndex(fields, 'amount')] < 0 },
              { black: item[getIndex(fields, 'amount')] === 0 }
            ]"
          >
            {{ item[getIndex(fields, "amount")] || 0 }}
          </span>
        </li>
        <li v-if="tickData.length < 12" style="width: 6px"></li>
      </ul>
    </div>
    <div style="height: 1px;"></div>
  </div>
</template>

<script>
import { OpenAPI } from '../../controller/datamanager/api.js'
import { numberFormat, getIndex } from "../../util/index.js";
import vueFunction from '../../util/vueFunction';
import { checkMRI, checkHKM } from "../../controller/util";
// numberFormat(item.business_amount / perHand, ratioFixed)
// let API = new OpenAPI()
export default {
  name: "transDetail",
  props: {
    prod_code: {
      type: String,
      default: ""
    },
    throttle: {
      type: Number,
      default: 3000
    }
  },
  computed: {
    showHand() {
      const arr = ["XSHG", "XBHS", "SS"];
      let szArr = ["SZ"],
        qhArr = ["CCFX", "XSGE", "XDCE", "XZCE", "SGE","CFFE", "SHFE", "DCE", "CZCE", "SHGE", "XSHO"];
      let typeNum = 0;
      if (
        checkMRI(this.prod_code, this.codeType) ||
        arr.some(a => new RegExp(a + "$").test(this.prod_code))
      ) {
        typeNum = 1;
      } else if (szArr.some(a => new RegExp(a + "$").test(this.prod_code))) {
        typeNum = 2;
      } else if (qhArr.some(a => new RegExp(a + "$").test(this.prod_code))) {
        typeNum = 3;
      } else {
        typeNum = 1;
      }
      return typeNum;
    },
    // 是否为指数
    isMRI() {
      let arr = ["XBHS", "GZZS"];
      return (
        checkMRI(this.prod_code, this.codeType) ||
        arr.some(a => new RegExp(a + "$").test(this.prod_code))
      );
    }
  },
  data() {
    return {
      timer: null,
      tickData: [],
      preclosePx: null,
      fixedNumType: 0,
      checkHKM: checkHKM,
      perHand: 1,
      codeType: null,
      getIndex: getIndex,
      fields: [],
      sortType: "mri"
    };
  },
  created() {
    //
    vueFunction
      .getToFixed(this.prod_code)
      .then(v => (this.fixedNumType = v));
    this.getDetail(
      this.prod_code,
      "business_time,hq_px,business_balance,business_count,business_amount,business_direction,amount"
    );
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    checkMRI(prod_code, codeType) {
      return checkMRI(prod_code, codeType);
    },
    numberFormats(value, ratioFixed = 2) {
      return numberFormat(value, ratioFixed);
      // return numberFormat(item.business_amount / perHand, ratioFixed)
    },
    getDetail(code, fields) {
      let realParams = {
        code,
        fields: "preclose_px,shares_per_hand,hq_type_code"
      };
      OpenAPI.real(realParams).then(async res => {
        console.log(res,'res-res-res');
        const preclose_px_index = getIndex(
          res.fields,
          "preclose_px"
        );
        const perHandIndex = getIndex(
          res.fields,
          "shares_per_hand"
        );
        const codeTypeIndex = getIndex(
          res.fields,
          "hq_type_code"
        );
        this.perHand = await res[code][perHandIndex];
        this.codeType = await res[code][codeTypeIndex];
        this.preclosePx = await res[code][preclose_px_index];
        if (this.preclosePx !== null) {
          this.getTickDataInterval(code, fields);
        }
      });
    },
    getTickDataInterval(code, fields) {
      let params = { code, fields };
      OpenAPI.tick(params).then(res => {
        this.fields = res.data.tick.fields;
        this.tickData = res.data.tick[code].sort(function(a, b) {
        // this.tickData = res.data.tick['989001.CNI'].sort(function(a, b) {
          const timeIndex = getIndex(res.data.tick.fields, "business_time");
          return b[timeIndex] - a[timeIndex];
        });
      });
      if (this.throttle > 0) {
        this.timer = setInterval(() => {
          OpenAPI.tick(params).then(res => {
            this.tickData = res.data.tick[code].sort(function(a, b) {
              const timeIndex = getIndex(res.data.tick.fields, "business_time");
              return b[timeIndex] - a[timeIndex];
            });
          });
        }, 10000);
      }

    }
  }
};
</script>

<style scoped lang="scss">
* {
  padding: 0;
  margin: 0;
  font-size: 14px;
  list-style-type: none;
  text-align: center;
  box-sizing: border-box;
}
.red {
  color: #ef4342;
}
.green {
  color: #2ab447;
}
.black {
  color: #000000;
}
.bg-red {
  /* background: #F9D9E4; */
  background: rgb(255, 253, 215);
}
.bg-green {
  /* background: #D3F5D4; */
  background: rgb(255, 253, 215);
}
.tab-header {
  height: 40px;
  color: #399bff;
  width: 98%;
  margin-right: 6px;
}
.box {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}

.innerbox ul > li:nth-child(1) {
  //  cursor: pointer;
}
.innerbox ul:hover {
  background: #e4edf3;
}
.innerbox ul:hover li span {
  background: #e4edf3;
}
.innerbox::-webkit-scrollbar {
  width: 6px;
}
.innerbox::-webkit-scrollbar-thumb {
  border-radius: 4px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(193, 193, 193, 193);
}
.innerbox::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
.scroll_bar_wzj {
  height: 100%;
  overflow-y: auto;
}
/*Edge*/
@supports (-ms-ime-align: auto) {
  .box .scroll_bar_wzj {
    box-sizing: content-box;
    margin-right: -10px;
    padding-right: 10px;
    li {
      &:nth-child(2) {
        span {
          margin-right: -7px;
        }
      }
      &:nth-child(3) {
        span {
          margin-right: -10px;
        }
        b {
          margin-right: -12px;
        }
      }
    }
  }
  .box1 .scroll_bar_wzj {
    box-sizing: content-box;
    margin-right: -10px;
    padding-right: 10px;
    li {
      &:nth-child(2) {
        span {
          margin-right: -5px;
        }
      }
      &:nth-child(3) {
        span {
          margin-right: -8px;
        }
        b {
          margin-right: -8px;
        }
      }
      &:nth-child(4) {
        span {
          margin-right: -10px;
        }
      }
    }
  }
  .box .scroll_bar_wzj:after,
  .box1 .scroll_bar_wzj:after {
    content: "";
    height: 16px;
    display: block;
  }
}
ul {
  padding: 0 15px;
  min-height: 28px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  color: #333;
  li {
    text-align: right;
    span {
      display: inline-block;
      text-align: right;
      // width: 85px;
      line-height: 24px;
    }
    &:nth-child(1) {
      text-align: left;
      width: 30%;
    }
    &:nth-child(2) {
      width: 31%;
    }
    &:nth-child(3) {
      width: 39%;
    }
  }
  > .upOrDown {
    display: flex;
    align-items: center;
    text-align: right;
    justify-content: center;
    width: 28%;
    position: relative;
    > b {
      position: absolute;
      right: 0;
      font-size: 16px;
      line-height: 12px;
      font-weight: bolder;
    }
    > span {
      position: absolute;
      right: 12px;
    }
    .upOrDownSpan {
      right: 12px;
    }
  }
}
.box1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;

  .tab-header {
    height: 40px;
    color: #399bff;
    width: 98%;
    margin-right: 6px;
  }
  ul {
    height: 28px;
    display: flex;
    width: 100%;
    padding: 0 15px;
    flex-direction: row;
    align-items: center;
    // cursor: pointer;
    > .upOrDown {
      display: flex;
      align-items: center;
      text-align: right;
      justify-content: center;
      width: 28%;
      position: relative;
      > b {
        position: absolute;
        right: 0;
        font-size: 16px;
        line-height: 12px;
        font-weight: bolder;
      }
      > span {
        position: absolute;
        right: 12px;
      }
      .upOrDownSpan {
        right: 12px;
      }
    }
    > li:nth-of-type(1) {
      width: 25%;
      text-align: left;
    }
    > li:nth-of-type(2) {
      width: 25%;
      text-align: right;
    }
    > li:nth-of-type(3) {
      width: 30%;
      text-align: right;
    }
    > li:nth-of-type(4) {
      width: 20%;
      text-align: right;
      // padding-right: 10px;
    }
  }
}
</style>
